import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Business', href: '#business' },
  { label: 'Partners', href: '#partners' },
  { label: 'Contact', href: '#contact' },
];

const businessAreas = [
  'Medical Equipment Supply',
  'Machine Vision Inspection',
  'Micro Detachable-Head Camera',
  'Global Business Consulting',
];

export default function FooterEn() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1A2530] text-white">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-5">
              <img
                src="https://public.readdy.ai/ai/img_res/c9e35ef3-6870-488e-85b2-c6c685056c55.png"
                alt="Fixcope"
                className="h-8 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 max-w-xs">
              Connecting the world through technology and trust.<br />
              A comprehensive technology solution company specializing in industrial vision inspection, global medical equipment supply, micro camera development, and overseas expansion consulting.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-3 text-sm text-gray-400">
                <i className="ri-mail-line text-[#FF8C3A]"></i>
                <span>info@fixcope.com</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-gray-400">
                <i className="ri-global-line text-[#FF8C3A]"></i>
                <span>www.fixcope.com</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-gray-400">
                <i className="ri-map-pin-2-line text-[#FF8C3A]"></i>
                <span>#320,Beobwon-ro 11gil7, Songpa-gu, Seoul, Korea</span>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-5 whitespace-nowrap">Navigation</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-sm text-gray-300 hover:text-[#FF8C3A] transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Business Areas */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-5 whitespace-nowrap">Business Areas</h4>
            <ul className="space-y-3">
              {businessAreas.map((area, i) => (
                <li key={i}>
                  <button
                    onClick={() => handleNavClick('#business')}
                    className="text-sm text-gray-300 hover:text-[#FF8C3A] transition-colors text-left cursor-pointer"
                  >
                    {area}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Large text */}
        <div className="overflow-hidden py-6 border-t border-white/5">
          <div className="text-[64px] md:text-[100px] font-bold text-white/5 tracking-tight leading-none select-none">
            FIXCOPE INC
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-6 border-t border-white/10">
          <p className="text-xs text-gray-500">
            © 2026 Fixcope. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
          </div>
        </div>
      </div>
    </footer>
  );
}
